import React, { useEffect, useState } from 'react';
import Seo from './Seo';
import { getSettings } from '../../services/api';

/**
 * Fetches photographer settings and injects SEO meta tags into the document head.
 * Decoupled from Hero so meta tags update once on mount regardless of section visibility.
 */
const SeoBoundary = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getSettings()
      .then((data) => {
        if (!cancelled) setSettings(data);
      })
      .catch(() => {
        /* keep static defaults from index.html */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Seo
      photographerName={settings?.photographer_name}
      tagline={settings?.tagline}
      bio={settings?.bio}
      heroImage={settings?.hero_images?.[0]}
    />
  );
};

export default SeoBoundary;
